// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-text{justify-content:center}.amount-input{max-width:50%}.chip-group .v-slide-group__content{justify-content:space-around}.amount-chip{min-width:10vh;justify-content:center;margin-right:10vh}.chip-text{font-size:large}.v-text-field{font-size:xx-large}.v-text-field input{text-align:center}.amount-group{padding-bottom:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
